import type { ValidDateRange } from "@/apis/shared/validDateRange.output";
import { validDateRangeSchema } from "@/apis/shared/validDateRange.output";
import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type ScheduleValidDateRangeInput,
  scheduleValidDateRangeInputSchema,
} from "./shared/validDateRange.input";

/**
 * Metadata for the fetchScheduleValidDateRange endpoint
 */
export const scheduleValidDateRangeMeta = {
  functionName: "fetchScheduleValidDateRange",
  endpoint: "/validdaterange",
  inputSchema: scheduleValidDateRangeInputSchema,
  outputSchema: validDateRangeSchema,
  sampleParams: {},
  endpointDescription: "Get the valid date range for schedule data.",
} satisfies EndpointMeta<ScheduleValidDateRangeInput, ValidDateRange>;

/**
 * Fetch function for retrieving the valid date range for schedule data
 */
const { fetch, useHook } = createFetchAndHook<
  ScheduleValidDateRangeInput,
  ValidDateRange
>({
  api: wsfScheduleApiMeta,
  endpoint: scheduleValidDateRangeMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/validDateRange.endpoints").scheduleValidDateRangeGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving the valid date range for schedule data
 */
export const fetchScheduleValidDateRange: FetchFactory<
  ScheduleValidDateRangeInput,
  ValidDateRange
> = fetch;

/**
 * React Query hook for retrieving the valid date range for schedule data
 */
export const useScheduleValidDateRange: HookFactory<
  ScheduleValidDateRangeInput,
  ValidDateRange
> = useHook;
